module.exports = __webpack_public_path__ + "img/羊角禄段贡园1.52541a72.png";